export default __webpack_public_path__ + "4470659f9fbb7d2ac58f2cca14c0d249.svg";